import { render, staticRenderFns } from "./PaymentDone.vue?vue&type=template&id=65d1e1c6"
import script from "./PaymentDone.vue?vue&type=script&lang=js"
export * from "./PaymentDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports